(function () {

    // Back-to-top button — replaces the scroll-back-to-top plugin.
    var btn = document.createElement('button');
    btn.id = 'nzp-back-to-top';
    btn.type = 'button';
    btn.setAttribute('aria-label', 'Back to top');
    btn.innerHTML = '&uarr;';
    document.body.appendChild(btn);

    function toggle() {
        btn.classList.toggle('is-visible', window.pageYOffset > 300);
    }
    window.addEventListener('scroll', toggle, { passive: true });
    btn.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    });

})();
